import { css } from 'styled-components';

export const redScrollBar = () => css`
  overflow-x: scroll;
  &::-webkit-scrollbar {
    color: ${({ theme }) => theme.colors.ttRed};
    width: 0rem;
    height: 0.25rem;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #d9d9d9;
    margin: 5px;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.ttRed};
    border-radius: 10px;
    background: #e21f26;
    height: 0.25rem;
  }
`;
